// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eRVV","buttons":"styles_buttons__3I5PM"};